// login-v2.js — Entrypoint for the React login page (Login-V2). Mounts into
// `#js--login-v2` at the existing `/authorization/` URL.
import React from 'react';
import { createRoot } from 'react-dom/client';

import '../configs/bootstrap-ui.js';

import ErrorHandler from '../modules/error/error-handler.screen.js';
import LoginPage from '../modules/login/LoginPage.js';

const rootEl = document.getElementById('js--login-v2');
if (rootEl) {
	const root = createRoot(rootEl);
	root.render(
		<ErrorHandler>
			<LoginPage />
		</ErrorHandler>
	);
}
